import { render, staticRenderFns } from "./index.vue?vue&type=template&id=56fdf8e2&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=coffee"
export * from "./index.vue?vue&type=script&lang=coffee"
import style0 from "./index.vue?vue&type=style&index=0&id=56fdf8e2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fdf8e2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Modal: require('/opt/build/repo/site/components/globals/modal/modal.vue').default})
